// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".columns-container[data-v-7a7a245a]{min-height:100vh}.label a[data-v-7a7a245a]{color:inherit}.right-content-container[data-v-7a7a245a]{max-width:80%}.line[data-v-7a7a245a]{width:100%;border:1px solid #aaa;height:1px}", ""]);
// Exports
module.exports = exports;
